module.exports = __webpack_public_path__ + "assets/img/B-75b51af7.png";